import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import PublicHeader from '../../components/PublicHeader';
import PublicFooter from '../../components/PublicFooter';
import './PublicPages.css';
import { CITIES } from './CityPage';
import { CUISINES } from './CuisinePage';

function LocationsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNavigate = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <div className="public-page">
      <SEO
        title="Find Restaurants by City & Cuisine - Where to Eat Near You"
        description="Browse restaurants by city or cuisine type. Hangrily works in 50+ major US cities and 12+ cuisine categories. Swipe with friends to decide where to eat tonight!"
        path="/locations"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://hangrily.app' },
            { '@type': 'ListItem', position: 2, name: 'Locations', item: 'https://hangrily.app/locations' }
          ]
        }}
      />
      <PublicHeader />

      {/* Hero Section */}
      <section className="page-hero">
        <h1>Works in Your City, for Any Cuisine</h1>
        <p className="hero-subtitle">
          Pick your city, pick your cuisine. We'll help you and your friends figure out where to eat.
        </p>
      </section>

      {/* Cities Section */}
      <section className="content-section">
        <h2 className="section-title">Major Cities</h2>
        <p className="section-subtitle">
          We've got restaurants covered in these cities (and more)
        </p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginTop: '40px' }}>
          {Object.entries(CITIES).map(([slug, city]) => (
            <Link 
              key={slug}
              to={`/city/${slug}`}
              className="mode-detail-card"
              style={{ padding: '32px', textAlign: 'center', cursor: 'pointer', textDecoration: 'none' }}
              onClick={() => window.scrollTo(0, 0)}
            >
              <h3 style={{ fontSize: '24px', marginBottom: '8px' }}>{city.name}, {city.state}</h3>
              <p style={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.6)', margin: '8px 0' }}>
                {city.population} • {city.restaurants} restaurants
              </p>
              <p style={{ fontSize: '15px', margin: 0 }}>
                Find restaurants in {city.name} →
              </p>
            </Link>
          ))}
        </div>
      </section>

      {/* Cuisines Section */}
      <section className="content-section">
        <h2 className="section-title">Pick Your Cuisine</h2>
        <p className="section-subtitle">
          Know what you want? Filter by cuisine and start swiping
        </p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginTop: '40px' }}>
          {Object.entries(CUISINES).map(([slug, cuisine]) => (
            <Link 
              key={slug}
              to={`/cuisine/${slug}`}
              className="mode-detail-card"
              style={{ padding: '32px', textAlign: 'center', cursor: 'pointer', textDecoration: 'none' }}
              onClick={() => window.scrollTo(0, 0)}
            >
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>{cuisine.emoji}</div>
              <h3 style={{ fontSize: '22px', marginBottom: '8px' }}>{cuisine.name}</h3>
              <p style={{ fontSize: '14px', margin: 0 }}>
                {cuisine.description}
              </p>
            </Link>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-banner">
        <div className="cta-content">
          <h2>Stop Arguing, Start Eating</h2>
          <p>Try it free, keep it if you like it</p>
          <button className="btn" onClick={() => handleNavigate('/try')}>
            Try It Free
          </button>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}

export default LocationsPage;
